<template>
  <div
    class="task-list-empty-state"
    :class="`task-list-empty-state--${variant}`"
    :data-testid="rootTestId"
  >
    <div class="task-list-empty-state__icon-circle" aria-hidden="true">
      <img :src="iconSrc" alt="" class="task-list-empty-state__icon" />
    </div>

    <h3 class="task-list-empty-state__title" data-testid="setup-tasklist__empty-title">
      {{ title }}
    </h3>

    <p class="task-list-empty-state__description" data-testid="setup-tasklist__empty-description">
      {{ description }}
    </p>

    <v-menu
      v-if="variant === 'no-templates'"
      offset-y
      :nudge-bottom="6"
      content-class="task-list-empty-state__add-menu"
      transition="fade-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          color="primary"
          class="task-list-empty-state__action text-none white--text"
          :disabled="actionDisabled"
          :data-testid="actionTestId"
        >
          <v-icon left small>mdi-plus</v-icon>
          {{ actionLabel }}
          <v-icon right small>mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <div
        class="task-list-empty-state__add-menu-panel"
        data-testid="setup-tasklist__empty-add-template-menu"
      >
        <p class="task-list-empty-state__add-menu-label ma-0">Select type</p>
        <button
          type="button"
          class="task-list-empty-state__add-menu-item"
          data-testid="setup-tasklist__empty-add-ar-btn"
          @click="$emit('add-template', arType)"
        >
          Account Reconciliation
        </button>
        <button
          type="button"
          class="task-list-empty-state__add-menu-item"
          data-testid="setup-tasklist__empty-add-checklist-btn"
          @click="$emit('add-template', checklistType)"
        >
          Checklist
        </button>
      </div>
    </v-menu>

    <v-btn
      v-else-if="showAction"
      color="primary"
      class="task-list-empty-state__action text-none white--text"
      :disabled="actionDisabled"
      :data-testid="actionTestId"
      @click="$emit('action')"
    >
      <v-icon v-if="showPlusIcon" left small>mdi-plus</v-icon>
      {{ actionLabel }}
    </v-btn>
  </div>
</template>

<script>
import './TaskListEmptyState.scss';

const ICON_ADD = '/img/icons/fbc-icons/NoCycleAdd.svg';
const ICON_FILTER = '/img/icons/fbc-icons/NoCycle.svg';

export default {
  name: 'TaskListEmptyState',

  props: {
    variant: {
      type: String,
      default: 'no-templates',
      validator: (v) => ['no-templates', 'no-custom-fields', 'filters'].includes(v),
    },
    cycleType: {
      type: String,
      default: 'FBC',
    },
    actionDisabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    rootTestId() {
      return `setup-tasklist__empty-state--${this.variant}`;
    },

    iconSrc() {
      return this.variant === 'filters' ? ICON_FILTER : ICON_ADD;
    },

    title() {
      if (this.variant === 'no-templates') return 'No Templates Yet';
      if (this.variant === 'no-custom-fields') return 'No Custom Fields Yet';
      return 'No results found';
    },

    description() {
      if (this.variant === 'no-templates') {
        return `Add your first ${this.cycleType} task template to build your organization's master task library.`;
      }
      if (this.variant === 'no-custom-fields') {
        return `Create custom fields to capture additional data on ${this.cycleType} task templates.`;
      }
      return 'No items match your current filters. Try adjusting your search or clear filters.';
    },

    showAction() {
      return true;
    },

    showPlusIcon() {
      return this.variant !== 'filters';
    },

    actionLabel() {
      if (this.variant === 'no-templates') return 'Add Template';
      if (this.variant === 'no-custom-fields') return 'Add Custom Field';
      return 'Clear Filters';
    },

    actionTestId() {
      if (this.variant === 'filters') return 'setup-tasklist__empty-clear-filters-btn';
      if (this.variant === 'no-custom-fields') return 'setup-tasklist__empty-add-field-btn';
      return 'setup-tasklist__empty-add-template-btn';
    },

    checklistType() {
      return this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.NORMAL;
    },

    arType() {
      return this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION;
    },
  },
};
</script>
